module.exports = __webpack_public_path__ + "img/section_warehouse.fd620779.png";